// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_loader__UPS2L {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: block;
  margin: 15px auto;
  position: relative;
  color: #fff;
  left: -100px;
  box-sizing: border-box;
  animation: style_shadowRolling__RF2ZG 2s linear infinite;
}

@keyframes style_shadowRolling__RF2ZG {
  0% {
    box-shadow: 0px 0 rgba(255, 255, 255, 0), 0px 0 rgba(255, 255, 255, 0),
      0px 0 rgba(255, 255, 255, 0), 0px 0 rgba(255, 255, 255, 0);
  }
  12% {
    box-shadow: 100px 0 white, 0px 0 rgba(255, 255, 255, 0),
      0px 0 rgba(255, 255, 255, 0), 0px 0 rgba(255, 255, 255, 0);
  }
  25% {
    box-shadow: 110px 0 white, 100px 0 white, 0px 0 rgba(255, 255, 255, 0),
      0px 0 rgba(255, 255, 255, 0);
  }
  36% {
    box-shadow: 120px 0 white, 110px 0 white, 100px 0 white,
      0px 0 rgba(255, 255, 255, 0);
  }
  50% {
    box-shadow: 130px 0 white, 120px 0 white, 110px 0 white, 100px 0 white;
  }
  62% {
    box-shadow: 200px 0 rgba(255, 255, 255, 0), 130px 0 white, 120px 0 white,
      110px 0 white;
  }
  75% {
    box-shadow: 200px 0 rgba(255, 255, 255, 0), 200px 0 rgba(255, 255, 255, 0),
      130px 0 white, 120px 0 white;
  }
  87% {
    box-shadow: 200px 0 rgba(255, 255, 255, 0), 200px 0 rgba(255, 255, 255, 0),
      200px 0 rgba(255, 255, 255, 0), 130px 0 white;
  }
  100% {
    box-shadow: 200px 0 rgba(255, 255, 255, 0), 200px 0 rgba(255, 255, 255, 0),
      200px 0 rgba(255, 255, 255, 0), 200px 0 rgba(255, 255, 255, 0);
  }
}
/* ❌❌❌❌❌❌❌❌❌❌❌❌❌MAIN LOADER ✅✅✅✅✅✅✅✅✅✅✅✅✅ */

.style_mainWrapper__7K8vc {
  width: 100%;
  height: 70vh;
  display: flex;
  flex: 1 1;
  justify-content: center;
  align-items: center;
}
.style_mainLoader__ZOSxV {
  width: 55px;
  height: 55px;
  border: 5px solid #bfbfbf;
  border-bottom-color: rgb(66, 66, 255);
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: style_rotation__Nxd6s 1s linear infinite;
  }

  @keyframes style_rotation__Nxd6s {
  0% {
      transform: rotate(0deg);
  }
  100% {
      transform: rotate(360deg);
  }
  } 


/* circle loader */

.style_loaderRound__\\+u-Gq {
  width: 48px;
  height: 48px;
  border: 5px solid #bfbfbf;
  border-bottom-color: #FF3D00;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: style_rotation__Nxd6s 1s linear infinite;
  }

  @keyframes style_rotation__Nxd6s {
  0% {
      transform: rotate(0deg);
  }
  100% {
      transform: rotate(360deg);
  }
  } `, "",{"version":3,"sources":["webpack://./src/commonComponents/loader/style.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,wDAA2C;AAC7C;;AAEA;EACE;IACE;gEAC4D;EAC9D;EACA;IACE;gEAC4D;EAC9D;EACA;IACE;kCAC8B;EAChC;EACA;IACE;kCAC8B;EAChC;EACA;IACE,sEAAsE;EACxE;EACA;IACE;mBACe;EACjB;EACA;IACE;kCAC8B;EAChC;EACA;IACE;mDAC+C;EACjD;EACA;IACE;oEACgE;EAClE;AACF;AACA,2CAA2C;;AAE3C;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,SAAO;EACP,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,qCAAqC;EACrC,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,mDAAsC;EACtC;;EAEA;EACA;MACI,uBAAuB;EAC3B;EACA;MACI,yBAAyB;EAC7B;EACA;;;AAGF,kBAAkB;;AAElB;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,mDAAsC;EACtC;;EAEA;EACA;MACI,uBAAuB;EAC3B;EACA;MACI,yBAAyB;EAC7B;EACA","sourcesContent":[".loader {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  display: block;\n  margin: 15px auto;\n  position: relative;\n  color: #fff;\n  left: -100px;\n  box-sizing: border-box;\n  animation: shadowRolling 2s linear infinite;\n}\n\n@keyframes shadowRolling {\n  0% {\n    box-shadow: 0px 0 rgba(255, 255, 255, 0), 0px 0 rgba(255, 255, 255, 0),\n      0px 0 rgba(255, 255, 255, 0), 0px 0 rgba(255, 255, 255, 0);\n  }\n  12% {\n    box-shadow: 100px 0 white, 0px 0 rgba(255, 255, 255, 0),\n      0px 0 rgba(255, 255, 255, 0), 0px 0 rgba(255, 255, 255, 0);\n  }\n  25% {\n    box-shadow: 110px 0 white, 100px 0 white, 0px 0 rgba(255, 255, 255, 0),\n      0px 0 rgba(255, 255, 255, 0);\n  }\n  36% {\n    box-shadow: 120px 0 white, 110px 0 white, 100px 0 white,\n      0px 0 rgba(255, 255, 255, 0);\n  }\n  50% {\n    box-shadow: 130px 0 white, 120px 0 white, 110px 0 white, 100px 0 white;\n  }\n  62% {\n    box-shadow: 200px 0 rgba(255, 255, 255, 0), 130px 0 white, 120px 0 white,\n      110px 0 white;\n  }\n  75% {\n    box-shadow: 200px 0 rgba(255, 255, 255, 0), 200px 0 rgba(255, 255, 255, 0),\n      130px 0 white, 120px 0 white;\n  }\n  87% {\n    box-shadow: 200px 0 rgba(255, 255, 255, 0), 200px 0 rgba(255, 255, 255, 0),\n      200px 0 rgba(255, 255, 255, 0), 130px 0 white;\n  }\n  100% {\n    box-shadow: 200px 0 rgba(255, 255, 255, 0), 200px 0 rgba(255, 255, 255, 0),\n      200px 0 rgba(255, 255, 255, 0), 200px 0 rgba(255, 255, 255, 0);\n  }\n}\n/* ❌❌❌❌❌❌❌❌❌❌❌❌❌MAIN LOADER ✅✅✅✅✅✅✅✅✅✅✅✅✅ */\n\n.mainWrapper {\n  width: 100%;\n  height: 70vh;\n  display: flex;\n  flex: 1;\n  justify-content: center;\n  align-items: center;\n}\n.mainLoader {\n  width: 55px;\n  height: 55px;\n  border: 5px solid #bfbfbf;\n  border-bottom-color: rgb(66, 66, 255);\n  border-radius: 50%;\n  display: inline-block;\n  box-sizing: border-box;\n  animation: rotation 1s linear infinite;\n  }\n\n  @keyframes rotation {\n  0% {\n      transform: rotate(0deg);\n  }\n  100% {\n      transform: rotate(360deg);\n  }\n  } \n\n\n/* circle loader */\n\n.loaderRound {\n  width: 48px;\n  height: 48px;\n  border: 5px solid #bfbfbf;\n  border-bottom-color: #FF3D00;\n  border-radius: 50%;\n  display: inline-block;\n  box-sizing: border-box;\n  animation: rotation 1s linear infinite;\n  }\n\n  @keyframes rotation {\n  0% {\n      transform: rotate(0deg);\n  }\n  100% {\n      transform: rotate(360deg);\n  }\n  } "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loader": `style_loader__UPS2L`,
	"shadowRolling": `style_shadowRolling__RF2ZG`,
	"mainWrapper": `style_mainWrapper__7K8vc`,
	"mainLoader": `style_mainLoader__ZOSxV`,
	"rotation": `style_rotation__Nxd6s`,
	"loaderRound": `style_loaderRound__+u-Gq`
};
export default ___CSS_LOADER_EXPORT___;
